import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send bearer token as backup (some browsers block third-party cookies in preview)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const formatTL = (n) => {
  const num = Number(n) || 0;
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(num);
};

export const formatNumber = (n, digits = 0) => {
  const num = Number(n) || 0;
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(num);
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR");
  } catch { return iso; }
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(", ");
  return e?.message || "Bir hata oluştu";
};

export const ROLE_LABELS = {
  admin: "Yönetici",
  accounting: "Muhasebe",
  marketing: "Pazarlama",
  fleet: "Filo Yöneticisi",
  supplier: "Tedarikçi",
};
